const IMPERSONATION_KEY = "impersonation_state";

export type ImpersonationState = {
	targetUserId: string | null;
	targetContactId: string;
	adminUsername: string;
	startUrl: string;
};

const isValidImpersonationState = (data: unknown): data is ImpersonationState => {
	if (typeof data !== "object" || data === null) return false;
	const obj = data as Record<string, unknown>;
	return (
		(typeof obj.targetUserId === "string" || obj.targetUserId === null) &&
		typeof obj.targetContactId === "string" &&
		obj.targetContactId.length > 0 &&
		typeof obj.adminUsername === "string" &&
		typeof obj.startUrl === "string"
	);
};

export const setImpersonation = (state: ImpersonationState) => {
	if (!isValidImpersonationState(state)) {
		console.error("Rejected invalid impersonation state");
		return;
	}
	sessionStorage.setItem(IMPERSONATION_KEY, JSON.stringify(state));
};

export const getImpersonation = (): ImpersonationState | null => {
	const data = sessionStorage.getItem(IMPERSONATION_KEY);
	if (!data) return null;

	try {
		const parsed: unknown = JSON.parse(data);
		if (isValidImpersonationState(parsed)) {
			return parsed;
		}
		// Invalid structure - remove corrupted data
		sessionStorage.removeItem(IMPERSONATION_KEY);
		return null;
	} catch {
		sessionStorage.removeItem(IMPERSONATION_KEY);
		return null;
	}
};

export const clearImpersonation = () => {
	sessionStorage.removeItem(IMPERSONATION_KEY);
};

export const isImpersonating = () => getImpersonation() !== null;
